"use client";

import { env } from "@/env";
import { cn } from "@ui/lib/utils";

import type { State } from "../state/reducer";

import { saveStateToSessionCookie } from "./utils";

export const CreateAccountButton = ({
  state,
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
  state: State;
}) => {
  return (
    <a
      className={cn(
        "font-soundboard f-ui-04 w-full rounded-sm bg-inverse px-16 py-12 text-center text-inverse",
        className,
      )}
      href={`${env.NEXT_PUBLIC_WEB_APP_URL}/sign-up?redirect=${encodeURIComponent(`/sound-effects/soundboard`)}`}
      onClick={() => saveStateToSessionCookie(state)}
      rel='noreferrer'
      target='_blank'
    >
      {children}
    </a>
  );
};
